import React, { useState } from 'react'
import NavBar from "./NavBar"
import Footer from "./Footer"
import security6 from "../../../assets/ethical6.svg"
import Hovered6 from "../../../assets/hoveredEthical16.svg"
import upparHover from "../../../assets/upparHover.svg"
import lowerHover from "../../../assets/lowerHover.svg"
import emailImg from "../../../assets/contact_mail.svg"
import countryHoverUpp from "../../../assets/countryuppar.svg"
import countryHoverLow from "../../../assets/countryLower.svg"
import connectWithout from "../../../assets/connect_without_contact.svg"
import ProfileImg from "../../../assets/profileImg.svg"

const AboutUs = () => {

  const count = [
    {
      numcount: "10k+",
      label: "Deal with recruiters"
    },
    {
      numcount: "1.5K+",
      label: "Team members "
    },
    {
      numcount: "1.7K+",
      label: "Hired candidates"
    },
    {
      numcount: "10K+",
      label: "Global candidates"
    }
  ]

  const cards = [
    {
      image: security6,
      hoveredImg: Hovered6,
      title: "Hiring team",
      desc: "We ensure that the hiring process is transparent, with clear communication to both candidates and businesses"
    },
    {
      image: security6,
      hoveredImg: Hovered6,
      title: "Job application & review",
      desc: "We ensure that AI and other technologies used on our platform only authorised personnel should have access to job applications, resumes, and other personal to maintain the transparency."
    }
  ]

  const info=[
    {
      label:"OUR MISSION",
      title:"Empowering Businesses with Global Talent",
      desc:"To connect businesses with skilled talent from around the world, enabling them to build diverse, high-performing teams. Leverage AI-powered solutions to simplify recruitment, making the hiring process faster, more accurate, and data-driven.Optimize and automate hiring workflows, reducing time-to-hire and ensuring better candidate matches for every role."
    },
    {
      label:"OUR MISSION",
      title:"Facilitating Efficient Hiring Processes",
      desc:"1800Hired is committed to transforming the recruitment process by providing businesses with an intuitive, efficient, and global platform to discover, evaluate, and hire the best talent in the world. 1800Hired is driven by a commitment to providing businesses with global, efficient, and diverse talent to build future-ready teams through smart recruitment technology."
    },
  ]

  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredPart, setIsHoveredPart] = useState(false);
  const [isHoveredCard, setIsHoveredCard] = useState(false);
  return (
    <>
      <NavBar />
      <div className='latest-product-feature'>
        <div className='latest-product-container' style={{ height: "260px" }}>
          <p className='latest-produt-url'>About our company </p>
          <p className='latest-product-desc'>Exclusive job search with personalised support to boost your business performance </p>
        </div>
      </div>
      <div className='about-us-count-container' style={{padding:"50px 4rem 30px 4rem"}}>
        <p className='count-card-count'>Reach your peak, we’ll help you get there.</p>
      </div>
       <section className="trusted-section">
          <div className="trusted-container">
        <div className="trusted-left-desc">
            <div className="trusted-description">
              <p>
                1800Hired.com offers AI-powered matching to find top talent fast, boosts productivity by streamlining hiring,
                and connects you to a global talent pool. It’s your smart hiring partner—transforming how you discover and engage
                exceptional candidates worldwide
              </p>
            </div>
            <div className="trusted-grid">
              <div className="trusted-item">
                <img src={countryHoverUpp} className="hover-lower" />
                <img src={countryHoverLow} className="hover-upper" />
                <img src={connectWithout} className="email-icon" />
                <p className="hover-title">20+ Countries</p>
                <p className="hover-desc">Have been with us for hiring candidate</p>
              </div>
              <div className="trusted-item">
                <img src={upparHover} className="hover-upper" />
                <img src={lowerHover} className="hover-lower" />
                <img src={emailImg} className="email-icon" />
                <p className="hover-title">5k+ Recruiters</p>
                <p className="hover-desc">Trusted globally for talent sourcing</p>
              </div>
               <div className="trusted-item">
  <img src={countryHoverUpp} className="hover-lower" />
  <img src={countryHoverLow} className="hover-upper" />
  <img src={ProfileImg} className="email-icon" />
  <p className="hover-title">80M+ Profiles </p>
  <p className="hover-desc">Has been created on 1800hired.com</p>
</div>
            </div>
          </div>
          </div>
       </section>
       
      <div className='about-us-desc-container'>
        <div className='about-us-left-part-second'>
             {
              info.map((card, index) => {
                return (
                  <div
                    key={index}
                    className="diff-card"
                    style={{ width: "100%" }}
                    onMouseEnter={() => setIsHoveredPart(index)}
                    onMouseLeave={() => setIsHoveredPart(null)}
                  >
                    <p
                      className={`diff-card-label ${isHoveredPart === index ? "diff-hovered-label" : ""
                        }`}
                    >
                      {card.label}
                    </p>
                     <p
                      className={`diff-card-head ${isHoveredPart === index ? "diff-hovered-desc" : ""
                        }`}
                    >
                      {card.title}
                    </p>
                    <p
                      className={`diff-card-desc ${isHoveredPart === index ? "diff-hovered-desc" : ""
                        }`}
                    >
                      {card.desc}
                    </p>
                  </div>
                )
              })
            }
        </div>
        <div className='about-us-right-part-second'>
            <div className='about-image-card'></div>
            <div className='about-image-card'></div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutUs